import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3be1e82c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "percentile ml-4" }
const _hoisted_2 = { class: "option" }
const _hoisted_3 = { class: "option-label" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "option-value" }
const _hoisted_7 = { class: "input-box mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sign" }, "%", -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.question.wording) + " ", 1),
        _hoisted_4,
        _withDirectives(_createElementVNode("textarea", {
          class: "text-area",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.fieldText) = $event)),
          maxlength: "150",
          onInput: _cache[1] || (_cache[1] = (...args) => (_ctx.onTextChanged && _ctx.onTextChanged(...args))),
          placeholder: _ctx.textAreaPlaceholder,
          onFocus: _cache[2] || (_cache[2] = $event => ($event.target.select()))
        }, null, 40, _hoisted_5), [
          [_vModelText, _ctx.fieldText]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["footnote", _ctx.fieldText.length === 150 ? 'full' : ''])
        }, _toDisplayString(_ctx.fieldText?.length || 0) + "/150 characters ", 3)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "0",
            max: "100",
            pattern: "[1-9]\\d*",
            onFocus: _cache[3] || (_cache[3] = $event => ($event.target.select())),
            onkeydown: "if(event.key==='.' || event.key==='-'){event.preventDefault();}",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.fieldValue) = $event))
          }, null, 544), [
            [_vModelText, _ctx.fieldValue]
          ]),
          _hoisted_8
        ])
      ])
    ])
  ]))
}